var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHrRiskIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3216 26.332L30.6144 30.005L26.9073 26.332C24.8756 26.332 23.2285 27.9765 23.2285 30.005V36.3984H38.0004V30.005C38.0004 27.9765 36.3533 26.332 34.3216 26.332Z",
    fill: "#4D4D4D",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5965 24.4926C32.8136 24.4926 34.6109 22.6981 34.6109 20.4846C34.6109 18.271 32.8136 16.4766 30.5965 16.4766C28.3794 16.4766 26.582 18.271 26.582 20.4846C26.582 22.6981 28.3794 24.4926 30.5965 24.4926Z",
    fill: "#949494"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53223 26.332H5.23962C2.34589 26.332 0 28.6742 0 31.5634V36.3984H14.7719V31.5634C14.7719 28.6742 12.426 26.332 9.53223 26.332Z",
    fill: "#4D4D4D",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36843 24.4926C9.58554 24.4926 11.3829 22.6981 11.3829 20.4846C11.3829 18.271 9.58554 16.4766 7.36843 16.4766C5.15133 16.4766 3.354 18.271 3.354 20.4846C3.354 22.6981 5.15133 24.4926 7.36843 24.4926Z",
    fill: "#949494"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.147 28.5996H16.8544C13.9606 28.5996 11.6147 30.9418 11.6147 33.831V36.3991H26.3866V33.831C26.3866 30.9418 24.0407 28.5996 21.147 28.5996Z",
    fill: "#B92250"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0008 26.4137C21.0264 26.4137 22.6685 24.7742 22.6685 22.7518C22.6685 20.7293 21.0264 19.0898 19.0008 19.0898C16.9751 19.0898 15.333 20.7293 15.333 22.7518C15.333 24.7742 16.9751 26.4137 19.0008 26.4137Z",
    fill: "#B92250"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0021 16.5757C19.0021 16.5757 11.1213 14.1453 11.3864 3.53967C13.1588 3.24124 14.6815 1.88054 14.6782 0H23.3259C23.3256 1.88096 24.8443 3.24333 26.6177 3.53967C26.8094 13.3602 19.0021 16.5757 19.0021 16.5757Z",
    fill: "#2D7ABE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9375 10.4656L15.1182 8.21375L17.1925 6.53779L18.0412 7.58815L20.9003 4.48633L22.8611 6.2937L18.9551 10.5313C18.7023 10.8056 17.6667 11.126 16.9375 10.4656Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrRiskIcon);
export default __webpack_public_path__ + "static/media/hrRiskIcon.122049f0.svg";
export { ForwardRef as ReactComponent };